if (!customElements.get("m-product-hero")) {
  // Product hero gallery, variants, reviews, and image zoom.
  class MProductHero extends HTMLElement {
    constructor() {
      super();
      this.onThumbClick = this.onThumbClick.bind(this);
      this.onSupplyClick = this.onSupplyClick.bind(this);
      this.onReviewToggle = this.onReviewToggle.bind(this);
      this.onZoomOpen = this.onZoomOpen.bind(this);
      this.onStagePointerDown = this.onStagePointerDown.bind(this);
      this.onStagePointerMove = this.onStagePointerMove.bind(this);
      this.onStagePointerUp = this.onStagePointerUp.bind(this);
      this.onThumbPointerDown = this.onThumbPointerDown.bind(this);
      this.onThumbPointerMove = this.onThumbPointerMove.bind(this);
      this.onThumbPointerUp = this.onThumbPointerUp.bind(this);
      this.onThumbNavClick = this.onThumbNavClick.bind(this);
      this.onThumbScroll = this.onThumbScroll.bind(this);
      this.onGalleryResize = this.onGalleryResize.bind(this);
      this.onTrackTransitionEnd = this.onTrackTransitionEnd.bind(this);
      this.lightbox = null;
      this.preloadedZoomSrc = "";
      this.galleryIndex = 0;
      this.loopSnapIndex = null;
      this.loopReady = false;
      this.thumbVisibleCount = 1;
      this.thumbMomentum = 0;
      this.suppressZoomClick = false;
      this.thumbDragMoved = false;
    }

    connectedCallback() {
      this.thumbs = Array.from(this.querySelectorAll("[data-ph-thumb]"));
      this.supplyCards = Array.from(this.querySelectorAll("[data-ph-supply]"));
      this.mainImageWrap = this.querySelector("[data-ph-main-image]");
      this.mainImage = this.mainImageWrap ? this.mainImageWrap.querySelector("img") : null;
      this.priceEl = this.querySelector("[data-ph-price]");
      this.variantInput = this.querySelector("[data-ph-variant-id]");
      this.sellingPlanInput = this.querySelector("[data-ph-selling-plan]");
      this.atcButton = this.querySelector(".m-product-hero__atc");
      this.atcLabelEl = this.querySelector("[data-ph-atc-label]");
      this.atcCompareEl = this.querySelector("[data-ph-atc-compare]");
      this.atcPriceEl = this.querySelector("[data-ph-atc-price]");
      this.atcLabel = this.dataset.atcLabel || "ADD TO CART";
      this.productUrl = this.dataset.productUrl || "";
      this.enableHistory = this.dataset.enableHistory === "true";
      this.planData = this.readPlanData();
      this.purchaseRoot = this.querySelector("[data-ph-purchase]");
      this.frequencySelect = this.querySelector("[data-ph-frequency]");
      this.frequencyTrigger = this.querySelector("[data-ph-frequency-trigger]");
      this.frequencyLabel = this.querySelector("[data-ph-frequency-label]");
      this.frequencyMenu = this.querySelector("[data-ph-frequency-menu]");
      this.onFrequencyTriggerClick = this.onFrequencyTriggerClick.bind(this);
      this.onFrequencyMenuClick = this.onFrequencyMenuClick.bind(this);
      this.onFrequencyOutsideClick = this.onFrequencyOutsideClick.bind(this);
      this.onetimeLink = this.querySelector("[data-ph-onetime-link]");
      this.onOnetimeLinkClick = this.onOnetimeLinkClick.bind(this);
      this.onetimePriceEl = this.querySelector("[data-ph-onetime-price]");
      this.subscribePriceEl = this.querySelector("[data-ph-subscribe-price]");
      this.comparePriceEl = this.querySelector("[data-ph-compare-price]");
      this.saveEl = this.querySelector("[data-ph-save]");
      this.subscribeMetaEl = this.querySelector("[data-ph-subscribe-meta]");
      this.onetimeMetaEl = this.querySelector("[data-ph-onetime-meta]");
      this.freqMonthEl = this.querySelector("[data-ph-freq-month]");
      this.freqCompareEl = this.querySelector("[data-ph-freq-compare]");
      this.freqSaveEl = this.querySelector("[data-ph-freq-save]");
      this.freqMetaEl = this.querySelector("[data-ph-freq-meta]");
      this.onetimeMonthEl = this.querySelector("[data-ph-onetime-month]");
      this.b2b = this.dataset.b2b === "true";
      const checkedType = this.querySelector("[data-ph-purchase-type]:checked");
      this.purchaseType = this.b2b ? "onetime" : checkedType ? checkedType.value : "subscribe";

      this.thumbs.forEach((thumb) => thumb.addEventListener("click", this.onThumbClick));
      this.supplyCards.forEach((card) => card.addEventListener("click", this.onSupplyClick));
      this.querySelectorAll("[data-ph-purchase-type]").forEach((input) => {
        input.addEventListener("change", this.onPurchaseTypeChange.bind(this));
      });
      if (this.onetimeLink) {
        this.onetimeLink.addEventListener("click", this.onOnetimeLinkClick);
      }
      if (this.frequencySelect) {
        this.frequencySelect.addEventListener("change", this.onFrequencyChange.bind(this));
      }
      if (this.frequencyTrigger) {
        this.frequencyTrigger.addEventListener("click", this.onFrequencyTriggerClick);
      }
      if (this.frequencyMenu) {
        this.frequencyMenu.addEventListener("click", this.onFrequencyMenuClick);
      }
      document.addEventListener("click", this.onFrequencyOutsideClick);
      if (this.mainImageWrap) this.mainImageWrap.addEventListener("click", this.onZoomOpen);
      this.initGallery();
      this.initLightbox();
      this.preloadCurrentZoom();
      this.bindReviewToggles();
      this.loadTaggedReviews();
      this.syncPurchaseUi();
      this.bindCheckoutRedirect();
    }

    disconnectedCallback() {
      this.thumbs.forEach((thumb) => thumb.removeEventListener("click", this.onThumbClick));
      this.supplyCards.forEach((card) => card.removeEventListener("click", this.onSupplyClick));
      if (this.mainImageWrap) this.mainImageWrap.removeEventListener("click", this.onZoomOpen);
      if (this.track) this.track.removeEventListener("transitionend", this.onTrackTransitionEnd);
      if (this.stage) this.stage.removeEventListener("pointerdown", this.onStagePointerDown);
      if (this.thumbRow) this.thumbRow.removeEventListener("pointerdown", this.onThumbPointerDown);
      if (this.thumbRow) this.thumbRow.removeEventListener("scroll", this.onThumbScroll);
      if (this.thumbPrev) this.thumbPrev.removeEventListener("click", this.onThumbNavClick);
      if (this.thumbNext) this.thumbNext.removeEventListener("click", this.onThumbNavClick);
      this.releaseStagePointer();
      this.releaseThumbPointer();
      this.cancelThumbMomentum();
      if (this.galleryObserver) {
        this.galleryObserver.disconnect();
        this.galleryObserver = null;
      }
      if (this.frequencyTrigger) {
        this.frequencyTrigger.removeEventListener("click", this.onFrequencyTriggerClick);
      }
      if (this.frequencyMenu) {
        this.frequencyMenu.removeEventListener("click", this.onFrequencyMenuClick);
      }
      document.removeEventListener("click", this.onFrequencyOutsideClick);
      if (this.onetimeLink) {
        this.onetimeLink.removeEventListener("click", this.onOnetimeLinkClick);
      }
      if (this.lightbox) {
        this.lightbox.destroy();
        this.lightbox = null;
      }
      this.querySelectorAll("[data-ph-review-toggle]").forEach((btn) => {
        btn.removeEventListener("click", this.onReviewToggle);
      });
      this.unbindCheckoutRedirect();
      if (this.taggedReviewsController) this.taggedReviewsController.abort();
    }

    onThumbClick(event) {
      if (this.thumbDragMoved) {
        this.thumbDragMoved = false;
        event.preventDefault();
        return;
      }
      const thumb = event.currentTarget;
      const index = this.thumbs.indexOf(thumb);
      if (this.slides && this.slides.length && index >= 0) {
        this.goToIndex(index, true);
        return;
      }
      this.setMainImage(thumb.dataset);
      this.setSelectedThumb(thumb.dataset.mediaId);
    }

    onSupplyClick(event) {
      const card = event.currentTarget;
      const variantId = card.dataset.variantId;
      if (!variantId) return;

      this.supplyCards.forEach((item) => {
        const selected = item === card;
        item.classList.toggle("is-selected", selected);
        const radio = item.querySelector("[role='radio']");
        if (radio) radio.setAttribute("aria-checked", selected ? "true" : "false");
      });

      if (this.variantInput) {
        this.variantInput.value = variantId;
        this.variantInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      this.syncPurchaseUi();
      this.showVariantImage(card);

      if (this.enableHistory && this.productUrl) {
        const url = `${this.productUrl}?variant=${variantId}`;
        window.history.replaceState({}, "", url);
      }
    }

    showVariantImage(card) {
      const mediaId = card && card.dataset.mediaId;
      if (!mediaId) return;
      const thumb = this.thumbs.find((item) => item.dataset.mediaId === mediaId);
      if (!thumb) return;
      this.setMainImage(thumb.dataset);
      if (!(this.slides && this.slides.length)) this.setSelectedThumb(mediaId);
    }

    setMainImage(data) {
      if (data && this.slides && this.slides.length && data.mediaId) {
        const index = this.slides.findIndex((slide) => slide.dataset.mediaId === data.mediaId);
        if (index >= 0) {
          this.goToIndex(index, true);
          return;
        }
      }
      if (!this.mainImage || !data.imageSrc) return;
      this.mainImage.src = data.imageSrc;
      if (data.imageSrcset) this.mainImage.srcset = data.imageSrcset;
      if (data.imageAlt) this.mainImage.alt = data.imageAlt;
      if (data.mediaId) this.mainImage.dataset.mediaId = data.mediaId;
      if (data.zoomSrc) this.mainImage.dataset.zoomSrc = data.zoomSrc;
      if (data.zoomSrcset) this.mainImage.dataset.zoomSrcset = data.zoomSrcset;
      if (data.zoomWidth) this.mainImage.dataset.zoomWidth = data.zoomWidth;
      if (data.zoomHeight) this.mainImage.dataset.zoomHeight = data.zoomHeight;
      this.preloadCurrentZoom();
    }

    getZoomItems() {
      if (this.thumbs.length) {
        return this.thumbs.map((thumb) => ({
          src: thumb.dataset.zoomSrc || thumb.dataset.imageSrc,
          srcset: thumb.dataset.zoomSrcset || "",
          width: parseInt(thumb.dataset.zoomWidth, 10) || 1600,
          height: parseInt(thumb.dataset.zoomHeight, 10) || 1600,
          alt: thumb.dataset.imageAlt || "",
          msrc: thumb.dataset.imageSrc || "",
          id: thumb.dataset.mediaId || "",
          element: this.mainImage,
        }));
      }

      if (!this.mainImage) return [];
      return [
        {
          src: this.mainImage.dataset.zoomSrc || this.mainImage.currentSrc || this.mainImage.src,
          srcset: this.mainImage.dataset.zoomSrcset || this.mainImage.srcset || "",
          width: parseInt(this.mainImage.dataset.zoomWidth, 10) || this.mainImage.naturalWidth || 1600,
          height: parseInt(this.mainImage.dataset.zoomHeight, 10) || this.mainImage.naturalHeight || 1600,
          alt: this.mainImage.alt || "",
          msrc: this.mainImage.currentSrc || this.mainImage.src,
          id: this.mainImage.dataset.mediaId || "",
          element: this.mainImage,
        },
      ];
    }

    getCurrentZoomIndex() {
      const mediaId = this.mainImage && this.mainImage.dataset.mediaId;
      if (!mediaId) return 0;
      const index = this.thumbs.findIndex((thumb) => thumb.dataset.mediaId === mediaId);
      return index >= 0 ? index : 0;
    }

    preloadCurrentZoom() {
      if (window.matchMedia("(max-width: 767px)").matches) return;
      const items = this.getZoomItems();
      const item = items[this.getCurrentZoomIndex()];
      if (!item || !item.src || item.src === this.preloadedZoomSrc) return;
      this.preloadedZoomSrc = item.src;
      const image = new Image();
      image.decoding = "async";
      if (item.srcset) image.srcset = item.srcset;
      image.src = item.src;
    }

    initLightbox() {
      const Lightbox = window.MinimogLibs && window.MinimogLibs.PhotoSwipeLightbox;
      if (!Lightbox || this.lightbox) return false;

      this.lightbox = new Lightbox({
        dataSource: this.getZoomItems(),
        pswpModule: Lightbox.PhotoSwipe,
        bgOpacity: 0.94,
        mainClass: "m-product-hero-zoom",
        pinchToClose: true,
        closeOnVerticalDrag: true,
        wheelToZoom: true,
        zoom: true,
        initialZoomLevel: "fit",
        secondaryZoomLevel: 2.4,
        maxZoomLevel: 4,
        showHideAnimationType: "zoom",
        preloadFirstSlide: true,
        preload: [1, 1],
        errorMsg: "The image cannot be loaded",
      });

      this.lightbox.addFilter("thumbEl", (thumbEl, data) => {
        if (this.mainImage && data && data.id && this.mainImage.dataset.mediaId === data.id) {
          return this.mainImage;
        }
        const thumb = data && data.id ? this.querySelector(`[data-ph-thumb][data-media-id="${data.id}"] img`) : null;
        return thumb || this.mainImage || thumbEl;
      });

      this.lightbox.addFilter("placeholderSrc", (placeholderSrc, content) => {
        const data = content && content.data;
        if (this.mainImage && data && data.id === this.mainImage.dataset.mediaId) {
          return this.mainImage.currentSrc || this.mainImage.src || placeholderSrc;
        }
        return (data && data.msrc) || placeholderSrc;
      });

      this.lightbox.on("change", () => {
        const slide = this.lightbox.pswp && this.lightbox.pswp.currSlide;
        const data = slide && slide.data;
        if (!data || !data.id) return;
        const thumb = this.querySelector(`[data-ph-thumb][data-media-id="${data.id}"]`);
        if (thumb) {
          this.setMainImage(thumb.dataset);
          this.setSelectedThumb(data.id);
        }
      });

      this.lightbox.init();
      return true;
    }

    waitForLightbox() {
      return new Promise((resolve) => {
        let attempts = 0;
        const tick = () => {
          if (this.initLightbox()) {
            resolve(true);
            return;
          }
          attempts += 1;
          if (attempts > 40) {
            resolve(false);
            return;
          }
          window.setTimeout(tick, 50);
        };
        tick();
      });
    }

    openLightbox() {
      if (!this.lightbox) return;
      this.lightbox.options.dataSource = this.getZoomItems();
      this.lightbox.loadAndOpen(this.getCurrentZoomIndex());
    }

    onZoomOpen(event) {
      if (this.suppressZoomClick) {
        this.suppressZoomClick = false;
        if (event) event.preventDefault();
        return;
      }
      if (event) event.preventDefault();
      if (!this.mainImage) return;
      if (this.lightbox || this.initLightbox()) {
        this.openLightbox();
        return;
      }
      this.waitForLightbox().then((ready) => {
        if (ready) this.openLightbox();
      });
    }

    setSelectedThumb(mediaId, behavior) {
      this.thumbs.forEach((thumb) => {
        const selected = mediaId && thumb.dataset.mediaId === mediaId;
        thumb.classList.toggle("is-selected", selected);
        thumb.setAttribute("aria-pressed", selected ? "true" : "false");
      });
      this.scrollSelectedThumbIntoView(behavior || "smooth");
    }

    initGallery() {
      this.stage = this.querySelector("[data-ph-stage]");
      this.track = this.querySelector("[data-ph-track]");
      this.slides = Array.from(this.querySelectorAll("[data-ph-slide]"));
      this.setupLoopSlides();
      this.thumbRow = this.querySelector(".m-product-hero__thumbs");
      this.thumbBar = this.querySelector(".m-product-hero__thumb-bar");
      this.thumbPrev = this.querySelector("[data-ph-thumb-prev]");
      this.thumbNext = this.querySelector("[data-ph-thumb-next]");
      const selectedIndex = this.thumbs.findIndex((thumb) => thumb.classList.contains("is-selected"));
      this.galleryIndex = selectedIndex >= 0 ? selectedIndex : 0;
      this.querySelectorAll(".m-product-hero__thumb img, .m-product-hero__slide img, .m-product-hero__main-image img").forEach((img) => {
        img.setAttribute("draggable", "false");
      });
      if (this.stage && this.slides.length > 1) {
        this.stage.addEventListener("pointerdown", this.onStagePointerDown);
      }
      if (this.track) this.track.addEventListener("transitionend", this.onTrackTransitionEnd);
      if (this.thumbRow && this.thumbs.length > 1) {
        this.thumbRow.addEventListener("pointerdown", this.onThumbPointerDown);
        this.thumbRow.addEventListener("scroll", this.onThumbScroll, { passive: true });
      }
      if (this.thumbPrev) this.thumbPrev.addEventListener("click", this.onThumbNavClick);
      if (this.thumbNext) this.thumbNext.addEventListener("click", this.onThumbNavClick);
      this.fitThumbs();
      this.positionTrack(false);
      this.scrollSelectedThumbIntoView("auto");
      if (typeof ResizeObserver !== "undefined") {
        this.galleryObserver = new ResizeObserver(this.onGalleryResize);
        if (this.stage) this.galleryObserver.observe(this.stage);
        if (this.thumbRow) this.galleryObserver.observe(this.thumbRow);
      }
    }

    onGalleryResize() {
      const thumbWidth = this.thumbRow ? this.thumbRow.clientWidth : 0;
      const stageWidth = this.stage ? this.stage.clientWidth : 0;
      if (thumbWidth === this.lastThumbWidth && stageWidth === this.lastStageWidth) return;
      this.lastThumbWidth = thumbWidth;
      this.lastStageWidth = stageWidth;
      this.fitThumbs();
      this.alignThumbs("auto");
      window.requestAnimationFrame(() => this.alignThumbs("auto"));
      if (!this.stageDrag && !(this.track && this.track.classList.contains("is-dragging"))) {
        this.positionTrack(false);
      }
    }

    fitThumbs() {
      const row = this.thumbRow;
      if (!row || !this.thumbs.length) return;
      const visibleWidth = row.clientWidth;
      if (visibleWidth < 1) {
        this.updateThumbNav();
        return;
      }
      const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      const size = this.thumbs[0].getBoundingClientRect().width || 1;
      let count = Math.floor((visibleWidth + gap) / (size + gap));
      count = Math.max(1, Math.min(5, this.thumbs.length, count));
      const overflowing = row.scrollWidth > visibleWidth + 1;
      this.thumbVisibleCount = overflowing ? count : this.thumbs.length;
      row.classList.toggle("is-overflowing", overflowing);
      this.updateThumbNav();
    }

    onThumbScroll() {
      this.updateThumbNav();
    }

    updateThumbNav() {
      const row = this.thumbRow;
      if (!this.thumbPrev || !this.thumbNext || !row) return;
      const max = Math.max(0, row.scrollWidth - row.clientWidth);
      row.classList.toggle("is-overflowing", max > 1);
      const canLoop = (this.slides && this.slides.length > 1) || this.thumbs.length > 1;
      this.thumbPrev.disabled = !canLoop;
      this.thumbNext.disabled = !canLoop;
    }

    onThumbNavClick(event) {
      const count = this.slides.length || this.thumbs.length;
      if (count < 2) return;
      event.preventDefault();
      this.cancelThumbMomentum();
      const direction = event.currentTarget === this.thumbNext ? 1 : -1;
      this.goToIndex(this.galleryIndex + direction, true);
    }

    prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    scrollBehavior(requested) {
      if (this.prefersReducedMotion()) return "auto";
      return requested || "smooth";
    }

    scrollSelectedThumbIntoView(behavior) {
      const row = this.thumbRow || this.querySelector(".m-product-hero__thumbs");
      const selected = this.thumbs.find((thumb) => thumb.classList.contains("is-selected"));
      if (!row || !selected) return;
      const view = row.clientWidth;
      const left = selected.offsetLeft;
      const right = left + selected.offsetWidth;
      if (left >= row.scrollLeft - 1 && right <= row.scrollLeft + view + 1) return;
      const index = this.thumbs.indexOf(selected);
      const visible = this.thumbVisibleCount || 1;
      const maxStart = Math.max(0, this.thumbs.length - visible);
      let start = index;
      if (right > row.scrollLeft + view + 1) start = Math.max(0, index - visible + 1);
      start = Math.max(0, Math.min(maxStart, start));
      const target = this.thumbs[start] ? this.thumbs[start].offsetLeft : 0;
      row.scrollTo({ left: target, behavior: this.scrollBehavior(behavior) });
    }

    alignThumbs(behavior) {
      const row = this.thumbRow;
      if (!row || !this.thumbs.length || row.classList.contains("is-dragging")) return;
      const visible = this.thumbVisibleCount || 1;
      const maxStart = Math.max(0, this.thumbs.length - visible);
      const found = this.thumbs.findIndex((thumb) => thumb.classList.contains("is-selected"));
      const selectedIndex = found >= 0 ? found : 0;
      let nearest = 0;
      let bestDist = Infinity;
      for (let i = 0; i <= maxStart; i += 1) {
        const dist = Math.abs(this.thumbs[i].offsetLeft - row.scrollLeft);
        if (dist < bestDist) {
          nearest = i;
          bestDist = dist;
        }
      }
      let start = nearest;
      if (selectedIndex < nearest) start = Math.min(maxStart, selectedIndex);
      else if (selectedIndex >= nearest + visible) start = Math.min(maxStart, selectedIndex - visible + 1);
      const target = this.thumbs[start] ? this.thumbs[start].offsetLeft : 0;
      if (Math.abs(row.scrollLeft - target) < 1) return;
      row.scrollTo({ left: target, behavior: this.scrollBehavior(behavior) });
    }

    snapThumbs(behavior) {
      const row = this.thumbRow;
      if (!row || !this.thumbs.length) return;
      const visible = this.thumbVisibleCount || 1;
      const maxStart = Math.max(0, this.thumbs.length - visible);
      let best = 0;
      let bestDist = Infinity;
      for (let i = 0; i <= maxStart; i += 1) {
        const dist = Math.abs(this.thumbs[i].offsetLeft - row.scrollLeft);
        if (dist < bestDist) {
          best = i;
          bestDist = dist;
        }
      }
      row.scrollTo({ left: this.thumbs[best].offsetLeft, behavior: this.scrollBehavior(behavior) });
    }

    cancelThumbMomentum() {
      if (this.thumbMomentum) {
        cancelAnimationFrame(this.thumbMomentum);
        this.thumbMomentum = 0;
      }
    }

    glideThumbs(velocity) {
      const row = this.thumbRow;
      if (!row) return;
      this.cancelThumbMomentum();
      let v = velocity;
      let last = performance.now();
      const tick = (now) => {
        const dt = Math.min(32, now - last);
        last = now;
        v *= Math.pow(0.9, dt / 16);
        const max = Math.max(0, row.scrollWidth - row.clientWidth);
        if (Math.abs(v) < 0.04 || max < 1) {
          this.thumbMomentum = 0;
          this.snapThumbs("smooth");
          return;
        }
        const next = row.scrollLeft + v * dt;
        if (next <= 0 || next >= max) {
          row.scrollLeft = Math.max(0, Math.min(max, next));
          this.thumbMomentum = 0;
          this.snapThumbs("smooth");
          return;
        }
        row.scrollLeft = next;
        this.thumbMomentum = requestAnimationFrame(tick);
      };
      this.thumbMomentum = requestAnimationFrame(tick);
    }

    onThumbPointerDown(event) {
      if (!this.thumbRow || !this.thumbRow.classList.contains("is-overflowing")) return;
      if (event.pointerType === "mouse" && event.button !== 0) return;
      this.cancelThumbMomentum();
      this.thumbRow.scrollLeft = this.thumbRow.scrollLeft;
      this.thumbDrag = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        scroll: this.thumbRow.scrollLeft,
        lastX: event.clientX,
        lastT: performance.now(),
        velocity: 0,
        axis: "",
        moved: false,
      };
      document.addEventListener("pointermove", this.onThumbPointerMove, { passive: false });
      document.addEventListener("pointerup", this.onThumbPointerUp);
      document.addEventListener("pointercancel", this.onThumbPointerUp);
    }

    onThumbPointerMove(event) {
      const drag = this.thumbDrag;
      if (!drag || event.pointerId !== drag.id || !this.thumbRow) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.axis) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        drag.axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        if (drag.axis === "y") {
          this.thumbDrag = null;
          this.releaseThumbPointer();
          return;
        }
        this.thumbRow.classList.add("is-dragging");
      }
      drag.moved = true;
      const now = performance.now();
      const dt = now - drag.lastT;
      if (dt > 0) drag.velocity = (event.clientX - drag.lastX) / dt;
      drag.lastX = event.clientX;
      drag.lastT = now;
      this.thumbRow.scrollLeft = drag.scroll - dx;
      event.preventDefault();
    }

    onThumbPointerUp(event) {
      const drag = this.thumbDrag;
      if (!drag || event.pointerId !== drag.id) return;
      this.thumbDrag = null;
      this.releaseThumbPointer();
      if (!this.thumbRow || drag.axis !== "x") return;
      this.thumbRow.classList.remove("is-dragging");
      if (!drag.moved) return;
      this.thumbDragMoved = true;
      window.setTimeout(() => {
        this.thumbDragMoved = false;
      }, 0);
      this.glideThumbs(-drag.velocity);
    }

    releaseThumbPointer() {
      document.removeEventListener("pointermove", this.onThumbPointerMove);
      document.removeEventListener("pointerup", this.onThumbPointerUp);
      document.removeEventListener("pointercancel", this.onThumbPointerUp);
    }

    syncActiveSlide() {
      const slide = this.slides[this.galleryIndex];
      if (!slide) return;
      const image = slide.querySelector("img");
      if (image) this.mainImage = image;
      this.slides.forEach((item, index) => {
        const active = index === this.galleryIndex;
        item.classList.toggle("is-active", active);
        item.setAttribute("aria-hidden", active ? "false" : "true");
        if (active) item.removeAttribute("tabindex");
        else item.setAttribute("tabindex", "-1");
      });
    }

    setupLoopSlides() {
      if (!this.track || this.slides.length < 2 || this.loopReady) return;
      const first = this.slides[0];
      const last = this.slides[this.slides.length - 1];
      const before = last.cloneNode(true);
      const after = first.cloneNode(true);
      [before, after].forEach((clone) => {
        clone.classList.remove("is-active");
        clone.removeAttribute("data-ph-slide");
        clone.setAttribute("aria-hidden", "true");
        clone.setAttribute("tabindex", "-1");
        clone.dataset.phClone = "true";
      });
      this.track.insertBefore(before, this.track.firstChild);
      this.track.appendChild(after);
      this.loopReady = true;
    }

    loopSlot(index) {
      if (!(this.slides.length > 1 && this.loopReady)) return index;
      return index + 1;
    }

    onTrackTransitionEnd(event) {
      if (event.target !== this.track || event.propertyName !== "transform") return;
      if (this.loopSnapIndex == null) return;
      this.loopSnapIndex = null;
      this.positionTrack(false);
    }

    positionTrack(animate, slot) {
      if (!this.track || !this.stage || !this.slides.length) return;
      const width = this.stage.clientWidth;
      if (!width) return;
      const index = slot == null ? this.loopSlot(this.galleryIndex) : slot;
      const x = -index * width + "px";
      if (!animate) {
        this.track.style.transition = "none";
        this.track.style.transform = "translate3d(" + x + ", 0, 0)";
        this.track.getBoundingClientRect();
        this.track.style.transition = "";
      } else {
        this.track.classList.remove("is-dragging");
        this.track.getBoundingClientRect();
        this.track.style.transform = "translate3d(" + x + ", 0, 0)";
      }
      this.syncActiveSlide();
    }

    goToIndex(index, animate) {
      const count = this.slides.length;
      if (!count) return;
      const loop = count > 1 && this.loopReady;
      const animateMove = !!animate && !this.prefersReducedMotion();
      let next = index;
      let slot = index;
      let viaClone = false;
      if (loop) {
        if (index >= count) {
          next = index % count;
          viaClone = true;
          slot = count + 1;
        } else if (index < 0) {
          next = ((index % count) + count) % count;
          viaClone = true;
          slot = 0;
        } else {
          next = index;
          slot = index + 1;
        }
      } else {
        next = Math.max(0, Math.min(count - 1, index));
        slot = next;
      }
      const changed = next !== this.galleryIndex;
      this.galleryIndex = next;
      if (viaClone && animateMove) {
        this.loopSnapIndex = next;
        this.positionTrack(true, slot);
      } else {
        this.loopSnapIndex = null;
        this.positionTrack(animateMove, loop ? next + 1 : next);
      }
      const slide = this.slides[next];
      if (slide) this.setSelectedThumb(slide.dataset.mediaId, animate ? "smooth" : "auto");
      if (changed) this.preloadCurrentZoom();
    }

    onStagePointerDown(event) {
      if (!this.stage || !this.track || this.slides.length < 2) return;
      if (event.pointerType === "mouse" && event.button !== 0) return;
      if (this.loopSnapIndex != null) {
        this.loopSnapIndex = null;
        this.positionTrack(false);
      }
      this.stageDrag = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        lastX: event.clientX,
        lastT: performance.now(),
        velocity: 0,
        axis: "",
        moved: false,
      };
      document.addEventListener("pointermove", this.onStagePointerMove, { passive: false });
      document.addEventListener("pointerup", this.onStagePointerUp);
      document.addEventListener("pointercancel", this.onStagePointerUp);
    }

    onStagePointerMove(event) {
      const drag = this.stageDrag;
      if (!drag || event.pointerId !== drag.id || !this.stage || !this.track) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        drag.axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        if (drag.axis === "y") {
          this.stageDrag = null;
          this.releaseStagePointer();
          return;
        }
        this.stage.classList.add("is-dragging");
        this.track.classList.add("is-dragging");
      }
      drag.moved = true;
      const now = performance.now();
      const dt = now - drag.lastT;
      if (dt > 0) drag.velocity = (event.clientX - drag.lastX) / dt;
      drag.lastX = event.clientX;
      drag.lastT = now;
      const width = this.stage.clientWidth;
      const origin = this.loopSlot(this.galleryIndex);
      const shift = dx;
      this.track.style.transform = "translate3d(" + (-origin * width + shift) + "px, 0, 0)";
      event.preventDefault();
    }

    onStagePointerUp(event) {
      const drag = this.stageDrag;
      if (!drag || event.pointerId !== drag.id) return;
      this.stageDrag = null;
      this.releaseStagePointer();
      if (!this.stage || !this.track || drag.axis !== "x") return;
      const width = this.stage.clientWidth || 1;
      const dx = event.clientX - drag.x;
      let next = this.galleryIndex;
      if (drag.moved && (dx <= -width * 0.16 || drag.velocity < -0.5)) next += 1;
      else if (drag.moved && (dx >= width * 0.16 || drag.velocity > 0.5)) next -= 1;
      this.stage.classList.remove("is-dragging");
      this.track.classList.remove("is-dragging");
      if (drag.moved) {
        this.suppressZoomClick = true;
        window.setTimeout(() => {
          this.suppressZoomClick = false;
        }, 0);
      }
      this.goToIndex(next, true);
    }

    releaseStagePointer() {
      document.removeEventListener("pointermove", this.onStagePointerMove);
      document.removeEventListener("pointerup", this.onStagePointerUp);
      document.removeEventListener("pointercancel", this.onStagePointerUp);
    }

    updatePrice(price) {
      if (this.priceEl && price) this.priceEl.textContent = price;
    }

    readPlanData() {
      const el = this.querySelector("[data-ph-selling-plans]");
      let data = {};
      if (el) {
        try {
          data = JSON.parse(el.textContent || "{}") || {};
        } catch (error) {
          data = {};
        }
      }
      const fallback = {
        "43111240827058": {
          title: "Regular - 50ml",
          price: 12099,
          plans: [
            { id: 3253567666, name: "Delivery every 3 weeks", price: 10284 },
            { id: 3253600434, name: "Delivery every 4 weeks", price: 10284 },
          ],
        },
        "43111240859826": {
          title: "Large - 100ml",
          price: 16488,
          plans: [
            { id: 3253633202, name: "Delivery every 6 weeks", price: 14015 },
            { id: 3253665970, name: "Delivery every 7 weeks", price: 14015 },
          ],
        },
        "43739750400178": {
          title: "XXL 250 ML (Refill Pack+ Spare Dropper Bottle)",
          price: 34700,
          plans: [
            { id: 3253698738, name: "Delivery every 12 weeks", price: 29495 },
            { id: 3253731506, name: "Delivery every 13 weeks", price: 29495 },
            { id: 3253764274, name: "Delivery every 14 weeks", price: 29495 },
            { id: 3253797042, name: "Delivery every 15 weeks", price: 29495 },
          ],
        },
      };
      Object.keys(fallback).forEach((id) => {
        if (!data[id] || !data[id].plans || !data[id].plans.length) {
          data[id] = fallback[id];
        }
      });
      return data;
    }

    formatMoney(cents) {
      const format =
        (window.MinimogSettings && window.MinimogSettings.money_format) || "${{amount}}";
      if (typeof formatMoney === "function") return formatMoney(cents, format);
      return `$${(Number(cents) / 100).toFixed(2)}`;
    }

    currentVariantId() {
      return this.variantInput ? String(this.variantInput.value) : "";
    }

    currentVariantPlans() {
      const entry = this.planData[this.currentVariantId()];
      return entry && Array.isArray(entry.plans) ? entry.plans : [];
    }

    planLabel(plan) {
      if (!plan || !plan.name) return "Delivered on subscription";
      return String(plan.name).replace(/^Delivery\s+/i, "Delivered ");
    }

    planWeeks(plan) {
      if (!plan) return 0;
      const match = String(plan.name || "").match(/(\d+)\s*week/i);
      return match ? Number(match[1]) : 0;
    }

    /* Delivery matches how long the bottle lasts. A 1 month supply uses the 4 week plan. */
    planForDays(plans, days) {
      if (!Array.isArray(plans) || !plans.length) return null;
      const supplyDays = Number(days || 0);
      const target = supplyDays === 30 ? 4 : supplyDays ? supplyDays / 7 : 0;
      const usable = plans.filter((plan) => this.planWeeks(plan) > 0);
      const list = usable.length ? usable : plans;
      if (!target) {
        return list.reduce((best, plan) => (this.planWeeks(plan) > this.planWeeks(best) ? plan : best), list[0]);
      }
      return list.reduce((best, plan) => {
        return Math.abs(this.planWeeks(plan) - target) < Math.abs(this.planWeeks(best) - target) ? plan : best;
      }, list[0]);
    }

    pickPlan(plans) {
      return this.planForDays(plans, this.currentSupplyCard()?.dataset.days);
    }

    /* Same delivery interval on another bottle, otherwise the longest plan. */
    planMatching(plans, weeks) {
      if (!Array.isArray(plans) || !plans.length) return null;
      if (weeks) {
        const match = plans.find((plan) => this.planWeeks(plan) === weeks);
        if (match) return match;
      }
      return this.pickPlan(plans);
    }

    /* Closest Recharge interval to how long the selected bottle lasts. */
    defaultPlan(plans) {
      const card = this.currentSupplyCard();
      const days = card ? Number(card.dataset.days || 0) : 0;
      const target = days ? days / 7 : 0;
      if (!target) return this.pickPlan(plans);
      return plans.reduce((best, plan) => {
        return Math.abs(this.planWeeks(plan) - target) < Math.abs(this.planWeeks(best) - target) ? plan : best;
      }, plans[0]);
    }

    ensureFrequencyOptions(plans) {
      if (!this.frequencySelect) return;
      const sorted = plans.slice().sort((a, b) => this.planWeeks(a) - this.planWeeks(b));
      const signature = sorted.map((plan) => plan.id).join(",");
      const previousWeeks = Number(this.frequencySelect.selectedOptions[0]?.dataset.weeks || 0);
      if (this.frequencySelect.dataset.signature !== signature) {
        this.frequencySelect.dataset.signature = signature;
        this.frequencySelect.innerHTML = sorted
          .map((plan) => {
            const weeks = this.planWeeks(plan);
            return `<option value="${plan.id}" data-weeks="${weeks}">${this.escapeHtml(this.planLabel(plan))}</option>`;
          })
          .join("");
        const target = previousWeeks || 0;
        const fallback = target ? null : this.defaultPlan(sorted);
        const match = sorted.reduce((best, plan) => {
          const goal = target || this.planWeeks(fallback);
          if (!best) return plan;
          return Math.abs(this.planWeeks(plan) - goal) < Math.abs(this.planWeeks(best) - goal) ? plan : best;
        }, null);
        if (match) this.frequencySelect.value = String(match.id);
      }
    }

    /* Chosen delivery frequency when the row layout is on. Otherwise the longest plan. */
    activePlan(plans) {
      if (!Array.isArray(plans) || !plans.length) return null;
      if (this.frequencySelect) {
        this.ensureFrequencyOptions(plans);
        const chosen = plans.find((plan) => String(plan.id) === String(this.frequencySelect.value));
        if (chosen) return chosen;
      }
      return this.pickPlan(plans);
    }

    formatMoneyWhole(cents) {
      const rounded = Math.round(Number(cents || 0) / 100) * 100;
      return this.formatMoney(rounded).replace(/[.,]00(?!.*\d)/, "");
    }

    /* A 30-day bottle is one month, so the crossed-out price is that variant's price, including cents. */
    oneTimeMonthCompare(oneCents, days) {
      const cents = Number(oneCents || 0);
      if (Number(days) === 30) {
        return { cents, label: this.formatMoney(cents) };
      }
      const month = Math.round((cents * 30.4) / Number(days || 1));
      return { cents: month, label: this.formatMoneyWhole(month) };
    }

    currentSupplyCard() {
      return this.supplyCards.find((card) => card.classList.contains("is-selected")) || this.supplyCards[0];
    }

    onPurchaseTypeChange(event) {
      if (this.b2b) {
        this.purchaseType = "onetime";
        this.syncPurchaseUi();
        return;
      }
      /* The delivery menu closes on top of One time purchase, so that click is not a real choice. */
      if (
        event.currentTarget.value === "onetime" &&
        this.frequencyChangedAt &&
        Date.now() - this.frequencyChangedAt < 500
      ) {
        const subscribeInput = this.querySelector('[data-ph-purchase-type][value="subscribe"]');
        if (subscribeInput) subscribeInput.checked = true;
        this.purchaseType = "subscribe";
        this.syncPurchaseUi();
        return;
      }
      this.purchaseType = event.currentTarget.value;
      this.syncPurchaseUi();
    }

    /* Switch subscribe <-> one-time without submitting. */
    setPurchaseType(type) {
      if (this.b2b) {
        this.purchaseType = "onetime";
        this.syncPurchaseUi();
        return;
      }
      const input = this.querySelector(`[data-ph-purchase-type][value="${type}"]`);
      if (!input) return;
      input.checked = true;
      this.purchaseType = type;
      this.syncPurchaseUi();
    }

    onOnetimeLinkClick(event) {
      event.preventDefault();
      const card = this.currentSupplyCard();
      if (card && card.dataset.available !== "true") return;

      const previousType = this.purchaseType;
      const input = this.querySelector('[data-ph-purchase-type][value="onetime"]');
      if (input) input.checked = true;
      this.purchaseType = "onetime";
      this.syncPurchaseUi();

      const form = this.querySelector(".m-product-hero__form form");
      if (form) form.requestSubmit();

      if (previousType === "onetime") return;
      const previousInput = this.querySelector(`[data-ph-purchase-type][value="${previousType}"]`);
      if (previousInput) previousInput.checked = true;
      this.purchaseType = previousType;
      this.syncPurchaseUi();
    }

    onFrequencyChange() {
      this.frequencyChangedAt = Date.now();
      const subscribeInput = this.querySelector('[data-ph-purchase-type][value="subscribe"]');
      if (subscribeInput && !subscribeInput.checked) {
        subscribeInput.checked = true;
        this.purchaseType = "subscribe";
      }
      this.closeFrequencyMenu();
      this.syncPurchaseUi();
    }

    onFrequencyTriggerClick(event) {
      event.preventDefault();
      event.stopPropagation();
      if (!this.frequencyMenu) return;
      const open = this.frequencyMenu.hasAttribute("hidden");
      if (open) this.openFrequencyMenu();
      else this.closeFrequencyMenu();
    }

    onFrequencyMenuClick(event) {
      const button = event.target.closest("[data-ph-frequency-option]");
      if (!button || !this.frequencySelect) return;
      event.preventDefault();
      event.stopPropagation();
      this.frequencySelect.value = button.dataset.phFrequencyOption;
      this.frequencySelect.dispatchEvent(new Event("change", { bubbles: true }));
    }

    onFrequencyOutsideClick(event) {
      if (!this.frequencyMenu || this.frequencyMenu.hasAttribute("hidden")) return;
      if (event.target.closest("[data-ph-freq]")) return;
      this.closeFrequencyMenu();
    }

    openFrequencyMenu() {
      if (!this.frequencyMenu) return;
      this.frequencyMenu.removeAttribute("hidden");
      if (this.frequencyTrigger) this.frequencyTrigger.setAttribute("aria-expanded", "true");
    }

    closeFrequencyMenu() {
      if (!this.frequencyMenu) return;
      this.frequencyMenu.setAttribute("hidden", "");
      if (this.frequencyTrigger) this.frequencyTrigger.setAttribute("aria-expanded", "false");
    }

    syncPurchaseUi() {
      const card = this.currentSupplyCard();
      const oneTimeCents = card ? Number(card.dataset.priceCents || 0) : 0;
      const plans = this.currentVariantPlans();
      const hasPlans = plans.length > 0;
      const subscribe = !this.b2b && this.purchaseType === "subscribe" && hasPlans;
      const selectedPlan = this.activePlan(plans);
      const displayCents = subscribe && selectedPlan ? Number(selectedPlan.price) : oneTimeCents;
      const displayPrice = this.formatMoney(displayCents);

      if (this.purchaseRoot) {
        this.purchaseRoot.hidden = !hasPlans;
      }
      this.classList.toggle("is-onetime", this.purchaseType === "onetime");
      const tiersBanner = this.querySelector("[data-ph-tiers-banner]");
      if (tiersBanner) tiersBanner.hidden = !hasPlans;

      this.querySelectorAll(".m-product-hero__offer, [data-ph-freq-card]").forEach((label) => {
        const input = label.querySelector("[data-ph-purchase-type]");
        label.classList.toggle("is-selected", Boolean(input && input.checked));
      });
      if (this.onetimeLink) {
        this.onetimeLink.classList.toggle("is-selected", this.purchaseType === "onetime");
      }

      const planWeeks = this.planWeeks(selectedPlan);
      const days = card ? Number(card.dataset.days || 0) : 0;
      const supplyLabel = card ? card.dataset.supplyLabel || "" : "";
      const saveCents = selectedPlan ? Math.max(0, oneTimeCents - Number(selectedPlan.price)) : 0;

      if (this.onetimePriceEl) this.onetimePriceEl.textContent = this.formatMoney(oneTimeCents);
      if (this.comparePriceEl) this.comparePriceEl.textContent = this.formatMoney(oneTimeCents);
      if (this.subscribePriceEl && selectedPlan) {
        this.subscribePriceEl.textContent = this.formatMoney(selectedPlan.price);
      }
      if (this.saveEl) {
        this.saveEl.textContent = saveCents ? `Save ${this.formatMoney(saveCents)}` : "";
      }
      if (this.subscribeMetaEl) {
        const supplyLength = supplyLabel || (days ? `${days} day` : "");
        if (supplyLength && planWeeks) {
          this.subscribeMetaEl.textContent = `${supplyLength} supply delivered every ${planWeeks} weeks`;
        } else if (supplyLength) {
          this.subscribeMetaEl.textContent = `${supplyLength} supply delivered every ${days} days`;
        } else {
          this.subscribeMetaEl.textContent = "";
        }
      }
      if (this.onetimeMetaEl) {
        this.onetimeMetaEl.textContent = this.freqMonthEl
          ? (supplyLabel ? `${supplyLabel} supply, delivered once` : "Delivered once")
          : supplyLabel
            ? `${supplyLabel} supply, delivered once`
            : "Delivered once";
      }
      if (this.onetimeMonthEl) {
        this.onetimeMonthEl.textContent = this.formatMoney(oneTimeCents);
      }
      if (this.freqMonthEl && selectedPlan) {
        const subCents = Number(selectedPlan.price);
        const discountPct = oneTimeCents > 0 ? Math.max(0, Math.round((1 - subCents / oneTimeCents) * 100)) : 0;
        this.freqMonthEl.textContent = this.formatMoney(subCents);
        if (this.freqCompareEl) {
          this.freqCompareEl.textContent = this.formatMoney(oneTimeCents);
          this.freqCompareEl.hidden = !(subCents < oneTimeCents);
        }
        if (this.freqSaveEl) {
          const saveText = this.freqSaveEl.querySelector("[data-ph-freq-save-text]");
          if (saveText) saveText.textContent = discountPct > 0 ? `Save ${discountPct}%` : "";
          this.freqSaveEl.hidden = discountPct <= 0;
        }
        this.querySelectorAll("[data-ph-freq-discount]").forEach((el) => {
          el.textContent = discountPct > 0 ? `${discountPct}% off` : "";
        });
        this.querySelectorAll("[data-ph-freq-amount]").forEach((el) => {
          el.textContent = discountPct > 0 ? `${discountPct}%` : "";
        });
        if (this.freqMetaEl) {
          this.freqMetaEl.textContent = planWeeks
            ? `Billed ${this.formatMoney(subCents)} every ${planWeeks} weeks`
            : "";
        }
      }

      const sellingPlanValue = subscribe && selectedPlan ? String(selectedPlan.id) : "";
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = sellingPlanValue;
        this.sellingPlanInput.disabled = !sellingPlanValue;
      }

      this.updatePrice(displayPrice);
      const atcCompare = subscribe && oneTimeCents > displayCents ? this.formatMoney(oneTimeCents) : "";
      this.updateAtc(displayPrice, !card || card.dataset.available === "true", atcCompare);
      this.updateTiers(subscribe, selectedPlan ? this.planWeeks(selectedPlan) : 0);
    }

    /* Refresh every tier card: per day, per month (with one-time compare), billing line, save pill. */
    /* Frequency card uses the selected bottle's Save % and asterisk, same as the stacked cards. */
    syncFrequencySave() {
      if (!this.freqSaveEl) return;
      const card = this.currentSupplyCard();
      const pct = card ? Number(card.dataset.savePct || 0) : 0;
      const saveText = this.freqSaveEl.querySelector("[data-ph-freq-save-text]");
      if (saveText) saveText.textContent = pct > 0 ? `Save ${pct}%` : "";
      const sourceMark = card ? card.querySelector(".m-product-hero__tier-mark") : null;
      let mark = this.freqSaveEl.querySelector(".m-product-hero__tier-mark");
      if (sourceMark && !mark) {
        mark = sourceMark.cloneNode(true);
        this.freqSaveEl.appendChild(mark);
      }
      if (mark) mark.hidden = !sourceMark;
      this.freqSaveEl.hidden = pct <= 0;
    }

    updateTiers(subscribe, preferredWeeks = 0) {
      const tiers = this.supplyCards.map((card) => {
        const days = Number(card.dataset.days || 0);
        const oneCents = Number(card.dataset.priceCents || 0);
        const entry = this.planData[card.dataset.variantId];
        const plan = entry ? this.planForDays(entry.plans, days) : null;
        const subCents = plan ? Number(plan.price) : oneCents;
        const weeks = this.planWeeks(plan);
        const useSub = subscribe && Boolean(plan);
        const cents = useSub ? subCents : oneCents;
        return { card, days, oneCents, subCents, weeks, useSub, cents };
      });
      const basePerDay = tiers.reduce((max, t) => (t.days ? Math.max(max, t.oneCents / t.days) : max), 0);

      tiers.forEach(({ card, days, oneCents, subCents, weeks, useSub, cents }) => {
        if (!days) return;
        const perDay = cents / days;
        const dayEl = card.querySelector("[data-ph-tier-day]");
        const monthEl = card.querySelector("[data-ph-tier-month]");
        const compareEl = card.querySelector("[data-ph-tier-month-compare]");
        const billingEl = card.querySelector("[data-ph-tier-billing]");
        const saveEl = card.querySelector("[data-ph-tier-save]");
        if (dayEl) dayEl.textContent = this.formatMoney(Math.round(perDay));
        if (monthEl) monthEl.textContent = this.formatMoneyWhole((cents * 30.4) / days);
        const compare = this.oneTimeMonthCompare(oneCents, days);
        const showCompare = useSub && subCents < oneCents;
        if (compareEl) {
          compareEl.textContent = compare.label;
          compareEl.hidden = !showCompare;
        }
        /* Bottle price under the size name is always the one-off price. */
        const priceEl = card.querySelector("[data-ph-tier-price]");
        if (priceEl) priceEl.textContent = this.formatMoney(oneCents);
        if (billingEl) {
          const supplyLabel = card.dataset.supplyLabel || "";
          billingEl.textContent = useSub && weeks
            ? `Billed ${this.formatMoney(subCents)} every ${weeks} weeks`
            : (supplyLabel ? `${supplyLabel} supply, delivered once` : "Delivered once");
        }
        if (saveEl) {
          const pct = basePerDay > 0 ? Math.round((1 - perDay / basePerDay) * 100) : 0;
          const saveText = saveEl.querySelector("[data-ph-tier-save-text]");
          const label = pct > 0 ? `Save ${pct}%` : "";
          if (saveText) saveText.textContent = label;
          else saveEl.textContent = label;
          saveEl.hidden = pct <= 0;
        }
        /* Perk copy "Lock in {discount} forever" uses the subscription saving, same figure as the pill. */
        const subPct = basePerDay > 0 ? Math.max(0, Math.round((1 - subCents / days / basePerDay) * 100)) : 0;
        card.querySelectorAll("[data-ph-tier-discount]").forEach((el) => {
          el.textContent = `${subPct}% off`;
        });
        card.querySelectorAll("[data-ph-tier-amount]").forEach((el) => {
          el.textContent = `${subPct}%`;
        });
        card.dataset.perDay = this.formatMoney(Math.round(perDay));
        card.dataset.savePct = String(basePerDay > 0 ? Math.max(0, Math.round((1 - perDay / basePerDay) * 100)) : 0);
        card.dataset.monthCents = String(Math.round((cents * 30.4) / days));
        card.dataset.compareMonthCents = showCompare ? String(compare.cents) : "";
        card.dataset.compareMonthLabel = showCompare ? compare.label : "";
        card.dataset.billing = billingEl ? billingEl.textContent : "";
      });
    }

    updateAtc(price, available, compare = "") {
      if (!this.atcButton) return;

      if (!available) {
        this.atcButton.disabled = true;
        const soldOut = this.dataset.soldoutLabel || "Sold out";
        if (this.atcLabelEl) this.atcLabelEl.textContent = soldOut;
        if (this.atcPriceEl) this.atcPriceEl.hidden = true;
        if (this.atcCompareEl) this.atcCompareEl.hidden = true;
        return;
      }

      this.atcButton.disabled = false;
      if (this.atcLabelEl) this.atcLabelEl.textContent = this.atcLabel;
      if (this.atcPriceEl && price) {
        this.atcPriceEl.textContent = price;
        this.atcPriceEl.hidden = false;
      }
      if (this.atcCompareEl) {
        this.atcCompareEl.textContent = compare;
        this.atcCompareEl.hidden = !compare;
      }
    }

    bindReviewToggles() {
      this.querySelectorAll("[data-ph-review-toggle]").forEach((btn) => {
        btn.hidden = false;
        btn.addEventListener("click", this.onReviewToggle);
      });
    }

    /* Judge.me tagged reviews: same public endpoint Judge.me's own Reviews Grid block calls, filtered by
       the tags set on the section. Nothing tagged (or any error) leaves the server-rendered reviews alone. */
    loadTaggedReviews() {
      const root = this.querySelector("[data-ph-reviews]");
      if (!root || !root.dataset.phReviewsTags) return;
      /* Reveal the slot once the tagged reviews are in (or the fallback is confirmed), 1.5s at the latest. */
      const reveal = () => root.classList.add("is-reviews-ready");
      const revealTimer = window.setTimeout(reveal, 1500);
      const tags = root.dataset.phReviewsTags
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);
      const shop = root.dataset.phReviewsShop;
      if (!tags.length || !shop || typeof fetch !== "function") {
        window.clearTimeout(revealTimer);
        reveal();
        return;
      }
      const limit = Math.max(1, Math.min(10, parseInt(root.dataset.phReviewsLimit, 10) || 5));

      const params = new URLSearchParams({
        shop_domain: shop,
        platform: "shopify",
        page: "1",
        per_page: String(limit),
        review_selection: "all",
      });
      tags.forEach((tag) => params.append("custom_tags[]", tag));

      this.taggedReviewsController = typeof AbortController === "function" ? new AbortController() : null;
      fetch(`https://api.judge.me/widgets/reviews_grid_widget_data?${params.toString()}`, {
        headers: { Accept: "application/json" },
        signal: this.taggedReviewsController ? this.taggedReviewsController.signal : undefined,
      })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          const reviews = data && Array.isArray(data.reviews) ? data.reviews.slice(0, limit) : [];
          if (reviews.length && this.isConnected) this.renderTaggedReviews(root, reviews);
        })
        .catch(() => {})
        .then(() => {
          window.clearTimeout(revealTimer);
          reveal();
        });
    }

    decodeEntities(value) {
      const raw = String(value || "");
      if (raw.indexOf("&") === -1) return raw.trim();
      const doc = new DOMParser().parseFromString(raw, "text/html");
      return (doc.documentElement.textContent || "").trim();
    }

    renderTaggedReviews(root, reviews) {
      root.querySelectorAll("[data-ph-review-toggle]").forEach((btn) => {
        btn.removeEventListener("click", this.onReviewToggle);
      });
      const starsSrc = root.dataset.starsSrc || "";
      const verifiedSrc = root.dataset.verifiedSrc || "";
      const frag = document.createDocumentFragment();

      /* Judge.me HTML-encodes these fields (e.g. I&#39;ve); decode before inserting as text. */
      const decode = (value) => {
        const raw = String(value || "");
        if (raw.indexOf("&") === -1) return raw.trim();
        const doc = new DOMParser().parseFromString(raw, "text/html");
        return (doc.documentElement.textContent || "").trim();
      };

      reviews.forEach((review) => {
        const title = decode(review.title);
        const body = decode(review.body);
        const author = decode(review.reviewer_name);
        if (!title && !body) return;

        const article = document.createElement("article");
        article.className = "m-product-hero__review";
        article.setAttribute("data-ph-review-source", "judgeme-tag");
        if (review.uuid) article.setAttribute("data-review-id", review.uuid);

        const bodyWrap = document.createElement("div");
        bodyWrap.className = "m-product-hero__review-body";
        if (title) {
          const titleEl = document.createElement("p");
          titleEl.className = "m-product-hero__review-title";
          titleEl.textContent = title;
          bodyWrap.appendChild(titleEl);
        }
        if (body) {
          const excerpt = document.createElement("p");
          excerpt.className = "m-product-hero__review-excerpt";
          const text = document.createElement("span");
          text.className = "m-product-hero__review-text";
          text.textContent = body;
          const more = document.createElement("button");
          more.type = "button";
          more.className = "m-product-hero__review-more";
          more.setAttribute("data-ph-review-toggle", "");
          more.setAttribute("aria-expanded", "false");
          more.textContent = "Read more";
          excerpt.appendChild(text);
          excerpt.appendChild(more);
          bodyWrap.appendChild(excerpt);
        }
        article.appendChild(bodyWrap);

        const meta = document.createElement("div");
        meta.className = "m-product-hero__review-meta";
        if (starsSrc) {
          const stars = document.createElement("img");
          stars.className = "m-product-hero__review-stars";
          stars.src = starsSrc;
          stars.alt = "";
          stars.width = 90;
          stars.height = 18;
          meta.appendChild(stars);
        }
        if (author) {
          const authorEl = document.createElement("div");
          authorEl.className = "m-product-hero__review-author";
          if (review.verified_buyer && verifiedSrc) {
            const verified = document.createElement("img");
            verified.className = "m-product-hero__review-verified";
            verified.src = verifiedSrc;
            verified.alt = "";
            verified.width = 14;
            verified.height = 18;
            authorEl.appendChild(verified);
          }
          const name = document.createElement("span");
          name.textContent = author;
          authorEl.appendChild(name);
          meta.appendChild(authorEl);
        }
        article.appendChild(meta);
        frag.appendChild(article);
      });

      if (!frag.childNodes.length) return;
      root.replaceChildren(frag);
      root.setAttribute("data-ph-reviews-source", "judgeme-tag");
      this.bindReviewToggles();
    }

    onReviewToggle(event) {
      event.preventDefault();
      const button = event.currentTarget;
      const review = button.closest(".m-product-hero__review");
      if (!review) return;
      const expanded = review.classList.toggle("is-expanded");
      button.textContent = expanded ? "Read less" : "Read more";
      button.setAttribute("aria-expanded", expanded ? "true" : "false");
    }

    escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    bindCheckoutRedirect() {
      this.checkoutForms = [];
      if (this.dataset.redirectCheckout !== "true") return;
      this.onCheckoutSubmit = this.onCheckoutSubmit.bind(this);
      this.onCheckoutPageShow = this.onCheckoutPageShow.bind(this);
      this.onCheckoutPageHide = this.onCheckoutPageHide.bind(this);
      this.onCheckoutVisible = this.onCheckoutVisible.bind(this);
      const forms = [];
      const mainForm = this.querySelector(".m-product-hero__form form");
      if (mainForm) forms.push(mainForm);
      forms.forEach((form) => form.addEventListener("submit", this.onCheckoutSubmit, true));
      this.checkoutForms = forms;
      window.addEventListener("pageshow", this.onCheckoutPageShow);
      window.addEventListener("pagehide", this.onCheckoutPageHide);
      document.addEventListener("visibilitychange", this.onCheckoutVisible);
    }

    unbindCheckoutRedirect() {
      if (this.checkoutForms && this.onCheckoutSubmit) {
        this.checkoutForms.forEach((form) => form.removeEventListener("submit", this.onCheckoutSubmit, true));
      }
      this.checkoutForms = [];
      if (this.onCheckoutPageShow) {
        window.removeEventListener("pageshow", this.onCheckoutPageShow);
      }
      if (this.onCheckoutPageHide) {
        window.removeEventListener("pagehide", this.onCheckoutPageHide);
      }
      if (this.onCheckoutVisible) {
        document.removeEventListener("visibilitychange", this.onCheckoutVisible);
      }
    }

    /* Mobile Safari and Chrome keep this page after checkout, spinner and click lock included. */
    onCheckoutPageShow(event) {
      if (!event.persisted && !this.checkoutLeft) return;
      this.releaseCheckoutLock();
    }

    onCheckoutPageHide(event) {
      if (!event.persisted) return;
      this.releaseCheckoutLock();
    }

    onCheckoutVisible() {
      if (document.visibilityState !== "visible" || !this.checkoutLeft) return;
      this.releaseCheckoutLock();
    }

    releaseCheckoutLock() {
      this.checkoutAttempt = (this.checkoutAttempt || 0) + 1;
      this.checkoutLeft = false;
      this.finishCheckoutAttempt();
    }

    onCheckoutSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.checkoutPending) return;

      const form = event.currentTarget;
      const productForm = form.closest("product-form");
      const attempt = (this.checkoutAttempt || 0) + 1;
      this.checkoutAttempt = attempt;
      this.checkoutPending = true;
      if (productForm) productForm.classList.add("m-spinner-loading");

      const routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
      const addUrl = routes.cart_add_url || "/cart/add";
      const root = routes.root || "/";
      const checkoutUrl = `${String(root).replace(/\/?$/, "/")}checkout`;
      const formData = new FormData(form);

      fetch(addUrl, {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (this.checkoutAttempt !== attempt) return;
          if (data && data.status) {
            this.finishCheckoutAttempt(productForm);
            const message = data.description || data.message || "Could not add this to the cart.";
            const target = form.querySelector(".m-product-form-message") || document.body;
            if (window.MinimogTheme && window.MinimogTheme.Notification) {
              window.MinimogTheme.Notification.show({
                target,
                method: "appendChild",
                type: "error",
                message,
                last: 3000,
                sticky: !form.querySelector(".m-product-form-message"),
              });
            }
            return;
          }
          this.checkoutLeft = true;
          window.location.assign(checkoutUrl);
        })
        .catch(() => {
          if (this.checkoutAttempt !== attempt) return;
          this.finishCheckoutAttempt(productForm);
        });
    }

    finishCheckoutAttempt(productForm) {
      this.checkoutPending = false;
      if (productForm) {
        productForm.classList.remove("m-spinner-loading");
        return;
      }
      this.querySelectorAll(".m-spinner-loading").forEach((el) => {
        el.classList.remove("m-spinner-loading");
      });
    }
  }

  customElements.define("m-product-hero", MProductHero);
}
